import { createContext, useContext, useEffect, useState } from "react";
import { signInWithPopup, signOut as fbSignOut } from "firebase/auth";
import axios from "axios";
import { toast } from "sonner";
import { auth, googleProvider } from "./firebase";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("sp_token");
    if (!token) return;
    axios
      .get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => setUser(res.data))
      .catch(() => localStorage.removeItem("sp_token"));
  }, []);

  const signIn = async () => {
    setBusy(true);
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const idToken = await result.user.getIdToken();
      const res = await axios.post(`${API}/auth/firebase-login`, { id_token: idToken });
      localStorage.setItem("sp_token", res.data.token);
      setUser(res.data.user);
      toast.success(`Welcome, ${res.data.user.name}! Signed in with your SocialPulse network identity.`);
    } catch (e) {
      if (e.code !== "auth/popup-closed-by-user" && e.code !== "auth/cancelled-popup-request") {
        toast.error("Sign-in failed. Please try again.");
      }
    } finally {
      setBusy(false);
    }
  };

  const signOut = async () => {
    try { await fbSignOut(auth); } catch (_) { /* ignore */ }
    localStorage.removeItem("sp_token");
    setUser(null);
    toast.info("Signed out.");
  };

  const updatePreferences = async (preferred_country) => {
    const token = localStorage.getItem("sp_token");
    const res = await axios.patch(`${API}/auth/preferences`, { preferred_country }, { headers: { Authorization: `Bearer ${token}` } });
    setUser(res.data);
    return res.data;
  };

  return <AuthCtx.Provider value={{ user, signIn, signOut, busy, updatePreferences }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
